import { LoadingButton } from "@mui/lab";
import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import useAuth from "app/hooks/useAuth";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { useState } from "react";

dayjs.extend(customParseFormat);

const UpdateApplicationDialog = ({
  id,
  isStatusJoined = false,
  loading = false,
  open,
  previousValue,
  onClose,
  onSubmit,
  proformaInvoices,
  taxInvoices
}) => {
  const { user } = useAuth();
  const [dateOfJoining, setDateOfJoining] = useState(
    previousValue.dateOfJoining != null && previousValue.dateOfJoining !== ""
      ? dayjs(previousValue.dateOfJoining, "D/M/YYYY")
      : null
  );
  const [dateOfInterview, setDateOfInterview] = useState(
    previousValue.dateOfInterview ? dayjs(previousValue.dateOfInterview, "D/M/YYYY") : null
  );
  const [dateOfInvoiceDue, setDateOfInvoiceDue] = useState(
    previousValue.dateOfInvoiceDue ? dayjs(previousValue.dateOfInvoiceDue, "D/M/YYYY") : null
  );
  const [dateOfExit, setDateOfExit] = useState(
    previousValue.dateOfExit ? dayjs(previousValue.dateOfExit, "D/M/YYYY") : null
  );

  const [salaryOffered, setSalaryOffered] = useState(+previousValue.salaryOffered || "");
  const [remark, setRemark] = useState(previousValue.remark || "");
  const [proformaId, setProformaId] = useState(previousValue.proformaInvoice || null);
  const [taxId, setTaxId] = useState(previousValue.taxInvoice || null);

  const resetValues = () => {
    setDateOfJoining(null);
    setDateOfInterview(null);
    setSalaryOffered("");
    setRemark("");
  };

  const handleSubmit = () => {
    const application = {
      jp_date_of_joining: dateOfJoining,
      jp_date_of_interview: dateOfInterview,
      jp_salary_offered: salaryOffered || 0,
      jp_invoice_due_date: dateOfInvoiceDue,
      jp_date_of_exit: dateOfExit,
      jp_remark: remark,
      jp_proforma_id: proformaId?.id,
      jp_tax_id: taxId?.id,
      jp_updated_by: user?.id
    };

    onSubmit({
      id,
      application
    });

    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={() => {
        resetValues();
        onClose();
      }}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle>Edit Offer Details</DialogTitle>
      <DialogContent>
        <Box display="flex" flexDirection="column" gap={2} mt={1}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              format="DD/MM/YYYY"
              label="Date of Joining"
              value={dateOfJoining}
              onChange={(newValue) => setDateOfJoining(newValue)}
            />
            <DatePicker
              format="DD/MM/YYYY"
              label="Date of Interview"
              value={dateOfInterview}
              onChange={(newValue) => setDateOfInterview(newValue)}
            />
            <DatePicker
              format="DD/MM/YYYY"
              label="Date of Exit"
              value={dateOfExit}
              onChange={(newValue) => setDateOfExit(newValue)}
            />
          </LocalizationProvider>
          <TextField
            label="Salary Offered"
            type="text"
            value={salaryOffered}
            onChange={(e) => {
              const value = e.target.value;
              // Only allow digits and empty string
              if (/^\d*$/.test(value)) {
                console.log("🚀 ~ UpdateApplicationDialog ~ value:", value);
                setSalaryOffered(value);
              }
            }}
            fullWidth
          />
          <TextField
            label="Remark"
            multiline
            minRows={3}
            value={remark}
            onChange={(e) => setRemark(e.target.value)}
            fullWidth
          />
          {isStatusJoined && (
            <>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  format="DD/MM/YYYY"
                  label="Invoice Due Date"
                  value={dateOfInvoiceDue}
                  onChange={(newValue) => setDateOfInvoiceDue(newValue)}
                />
              </LocalizationProvider>
              <Autocomplete
                value={proformaId}
                options={proformaInvoices}
                isOptionEqualToValue={(option, value) => option.id === value.jp_id}
                getOptionLabel={(option) => option.label || option.jp_invoice_no}
                onChange={(_, value) => setProformaId(value)}
                renderInput={(params) => <TextField {...params} label="Proforma Invoices" />}
              />
              <Autocomplete
                value={taxId}
                options={taxInvoices}
                isOptionEqualToValue={(option, value) => option.id === value.jp_id}
                getOptionLabel={(option) => option.label || option.jp_invoice_no}
                onChange={(_, value) => setTaxId(value)}
                renderInput={(params) => <TextField {...params} label="Tax Invoices" />}
              />
            </>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined">
          Cancel
        </Button>
        <LoadingButton loading={loading} onClick={handleSubmit} variant="contained">
          Save
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default UpdateApplicationDialog;
